/*
 * VÀLIEN — ürün sayfası arayüz davranışları · 13.09.2026 (rev.4)
 *
 * 1) Açıklamanın İKİNCİ parçasındaki <h3> başlıklarını açılır-kapanır yapıyor.
 * 2) "Nasıl Kullanılır?" kutusuna sınıf takıyor ki CSS ile sıkıştırılabilsin —
 *    o kutu ürün açıklamasında satır içi stille geliyor, sınıfı yok.
 * 3) Üstteki "62 değerlendirme" rozetine tıklanınca sayfanın altındaki
 *    değerlendirmeler bölümüne kaydırıyor.
 *
 * NEYE DOKUNMAZ:
 *   • .valien-product — sepete ekle butonunun ÜSTÜNDEKİ parça. "Öne Çıkan
 *     İçerikler" ✓ listesi ve "Nasıl Kullanılır?" orada ve açık kalır.
 *   • .pf-faq — SSS zaten kendi <details> yapısını taşıyor.
 *
 * NEDEN TEMADA: Aynı sonucu 19 ürünün descriptionHtml'ini yeniden yazarak da
 * elde edebilirdik. Bu projede daha önce açıklama verisi kaybı yaşanmış.
 * Ürün verisine dokunmayan bu yol o riski ortadan kaldırıyor.
 */
(function () {
  'use strict';

  /* ---------- 1) İkinci parça akordiyonu ---------- */

  function collectScopes() {
    var scopes = [];
    var faqs = document.querySelectorAll('.pf-faq');

    for (var i = 0; i < faqs.length; i++) {
      var parent = faqs[i].parentElement;
      if (!parent) continue;
      if (parent.classList.contains('valien-product')) continue;
      if (scopes.indexOf(parent) === -1) scopes.push(parent);
    }

    return scopes;
  }

  function wrap(scope) {
    if (scope.dataset.vpAcc === '1') return;
    scope.dataset.vpAcc = '1';
    scope.classList.add('vp-desc2');

    var kids = Array.prototype.slice.call(scope.children);

    for (var i = 0; i < kids.length; i++) {
      var head = kids[i];
      if (head.tagName !== 'H3') continue;

      var details = document.createElement('details');
      details.className = 'vp-acc';

      var summary = document.createElement('summary');
      summary.className = 'vp-acc__sum';
      summary.textContent = (head.textContent || '').trim();
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'vp-acc__body';
      details.appendChild(body);

      scope.insertBefore(details, head);
      head.remove();

      var node = details.nextElementSibling;
      while (
        node &&
        node.tagName !== 'H3' &&
        !node.classList.contains('pf-faq') &&
        !node.classList.contains('valien-ns') &&
        !node.classList.contains('vp-acc')
      ) {
        var next = node.nextElementSibling;
        body.appendChild(node);
        node = next;
      }
    }
  }

  /* ---------- 2) "Nasıl Kullanılır?" kutusu ---------- */

  function tagSteps() {
    var boxes = document.querySelectorAll('.valien-product div[style*="#dcc9b8"]');

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.classList.contains('vp-steps')) continue;
      box.classList.add('vp-steps');

      var rows = box.querySelectorAll(':scope > div');
      for (var j = 0; j < rows.length; j++) rows[j].classList.add('vp-steps__row');
    }
  }

  /* ---------- 3) Değerlendirme rozeti → değerlendirmeler bölümü ---------- */

  function linkReviewBadge() {
    /*
     * Bölüm id'si şablona göre değişiyor, örn:
     *   shopify-section-template--20746397417634__judgeme_reviews
     * O yüzden sabit id yerine parça eşleşmesi kullanılıyor.
     */
    var target =
      document.querySelector('[id*="judgeme_reviews"]') ||
      document.querySelector('.jm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews_widget');
    if (!target) return;

    /*
     * Üstteki özet rozet temaya ait: .rating-wrapper — yıldızlar ve
     * "62 değerlendirme" yazısı. Judge.me'nin kendi rozeti de kullanılıyorsa
     * o da bağlanır. Alttaki widget'ın içindekiler hariç tutuluyor.
     */
    var badges = document.querySelectorAll('.rating-wrapper, .jdgm-prev-badge');

    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (badge.dataset.vpJump === '1') continue;
      if (target.contains(badge)) continue;
      badge.dataset.vpJump = '1';

      badge.style.cursor = 'pointer';
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('title', 'Değerlendirmelere git');

      badge.addEventListener('click', function (event) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      badge.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  function run() {
    try { collectScopes().forEach(wrap); } catch (e) {}
    try { tagSteps(); } catch (e) {}
    try { linkReviewBadge(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  /* Judge.me widget'ı geç basabiliyor — birkaç kez daha dene. */
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    try { linkReviewBadge(); } catch (e) {}
    if (tries > 12) clearInterval(timer);
  }, 700);

  document.addEventListener('shopify:section:load', run);
})();
